import {BehaviorSubject, Subject} from 'rxjs';
import {DISABLE_LANGS, LANGUAGES} from '@/const/lang';
import {fixInvalidLang} from '@/helper/localized-site';

export const loading$ = new Subject();
export const query$ = new Subject();

const validLangs = LANGUAGES.filter((item) => !DISABLE_LANGS.includes(item.value));
const langs = validLangs.filter((e) => fixInvalidLang(e.value) === e.value);

export const languages$ = new BehaviorSubject(langs);
